import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { MultiPlaybackActions } from '@states/multi-playback/multi-playback.action-types';
import { SharedActions } from '@states/shared/shared.action-types';
import { EdgeActions } from '@states/edge/edge.action-types';
import * as AlertMonitoringActions from '@states/alert-monitoring/alert-monitoring.actions';
import { WallV2Actions } from '@states/wall-v2/wall-v2.action-types';
import { AlertEventsActions } from '@states/alert-events/alert-events.action-types';
import { GetEdgeLocalNetworkV3 } from '@states/edge/edge.actions';
import { CameraActions } from '@states/camera/camera.action-types';
import { environment } from '../../../environments/environment';
import { ArchiveActions } from '@states/archive/archive.action-types';
import { ThumbnailsActions } from '@states/thumbnails/thumbnails.action-types';

export const extModules = environment.production ? [] : [
  StoreDevtoolsModule.instrument({
    maxAge: 100,
    actionsBlocklist: [
      SharedActions.setInactivityTime.type,
      MultiPlaybackActions.setMove.type,
      MultiPlaybackActions.setDefault.type,
      SharedActions.doNothing.type,
      EdgeActions.ClassifyIpAddress.type,
      AlertMonitoringActions.setNewAlerts.type,
      AlertMonitoringActions.archiveAlertSuccess.type,
      AlertMonitoringActions.newAlertsValidation.type,
      AlertMonitoringActions.refreshAlertsByAutoAcknowledgesAndFrequency.type,
      MultiPlaybackActions.setData.type,
      SharedActions.setInactivityCountdown.type,
      WallV2Actions.updatePlaybackVideoTimeForAlertId.type,
      AlertEventsActions.getEventSyncStatus.type,
      AlertEventsActions.getEventSyncStatusSuccess.type,
      GetEdgeLocalNetworkV3.type,
      CameraActions.getProperFitting.type,
      EdgeActions.SavePulsations.type,
      ArchiveActions.archiveProgressSocketUpdate.type,
      ThumbnailsActions.setBitsCache.type
    ],
    connectInZone: true,
  }),
];
